import * as React from "react";
import type { OccupancyTotals } from "./occupancyStatistics";

interface OccupancySummaryProps {
  totals: OccupancyTotals;
  hideLabel?: boolean;
}

const metrics: { key: keyof OccupancyTotals; label: string }[] = [
  { key: "totalTables", label: "Total seats" },
  { key: "occupiedTables", label: "Occupied by employees" },
  { key: "availableTables", label: "Free seats" },
  { key: "occupiedByInternTables", label: "Interns" },
  { key: "reservedTables", label: "Reserved seats" },
];

export const OccupancySummary: React.FC<OccupancySummaryProps> = ({ totals, hideLabel }) => (
  <span className="occupancy-overview__metrics">
    {metrics.map(({ key, label }) => (
      <span className="stats-results__content" style={{ textAlign: "center" }} key={key}>
        {!hideLabel ? (
          <>
            <strong>{label}:</strong>&nbsp;
          </>
        ) : null}
        <span className="occupancy-overview__value">{totals[key]}</span>
      </span>
    ))}
  </span>
);
